import { Widgets } from '@modules/common/constants';
import { useSearchStore } from '@modules/feed/store/searchStore';
import {
  getUseInQuantifyV2Link,
  trackSearchAnalysesWidgetsEvents,
} from '@modules/feed/utils';
import { InsightsRounded } from '@mui/icons-material';
import { Box, Button, Tooltip } from '@mui/material';
import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { EmptyWhereClause } from 'v2/core/services/queryBuilder/whereClause';

interface ShowInQuantifyButtonProps {
  shouldOpenInSameTab?: true;
  widget: Widgets;
}

export const ShowInQuantifyButton = ({
  shouldOpenInSameTab = true,
  widget,
}: ShowInQuantifyButtonProps) => {
  const baseCondition = useSearchStore(({ query }) => query?.baseCondition);
  const duration = useSearchStore(({ query }) => query?.duration);
  const whereClause = useSearchStore(({ query }) => query?.whereClause);

  const linkTo = useMemo(() => {
    return getUseInQuantifyV2Link({
      baseCondition,
      duration,
      whereClause: whereClause ?? EmptyWhereClause,
      widget,
    });
  }, [baseCondition, duration, whereClause, widget]);

  return (
    <Tooltip
      title={
        linkTo
          ? 'See more in Quantify'
          : 'See more in Quantify (Disabled due to unsupported filters)'
      }
      placement="top"
    >
      <Box component="span">
        <Button
          component={Link}
          color="primary"
          variant="outlined"
          size="small"
          disabled={!linkTo}
          to={linkTo ?? ''}
          target={shouldOpenInSameTab ? '_blank' : '_self'}
          sx={{ minWidth: '20px', p: 0.5 }}
          onClick={() => {
            trackSearchAnalysesWidgetsEvents({
              eventName: 'See More in Quantify Clicked',
              widget,
            });
          }}
        >
          <InsightsRounded fontSize="small" />
        </Button>
      </Box>
    </Tooltip>
  );
};
